import React from 'react';
import { MdAddPhotoAlternate } from 'react-icons/md';
import Dropzone from './Dropzone';
import FramiButton from '../common/FramiButton';
import { useCookies } from 'react-cookie';
import { useIntl } from 'react-intl';
import { useAuth, useComposition, useNavigation } from '../../context';
import ToolbarAnimatedHint from './ToolbarAnimatedHint';
import { usePosthog } from '../../providers/PosthogProvider';

const UploadPhotosButton = () => {
    const posthog = usePosthog();
    const [cookies, setCookie] = useCookies(['photosUploadDrawerClickHintSeen']);
    const { missingImages } = useComposition();
    const { isFeatureFlagAvailable } = useAuth();
    const { activeHint } = useNavigation();
    const intl = useIntl();


    const actionButtonTitle = intl.formatMessage(
        { id: 'studio.button.action.upload_photos' }
    );

    const handleClick = async () => {
        if (!cookies.photosUploadDrawerClickHintSeen) {
            setCookie('photosUploadDrawerClickHintSeen', true, {
                expires: 0,
                path: '/',
            });
        }
    };

    return (
        <Dropzone>
            <FramiButton
                style={{ width: '100%' }}
                className={'action-button uppercase'}
                dataPh={'floating bottom upload photos and open modal'}
                leftIcon={<MdAddPhotoAlternate />}
                variant="primary"
                onClick={handleClick}
                title={actionButtonTitle}
                dataCy={'missing_images'}
            />
            {activeHint === 2 &&
                isFeatureFlagAvailable &&
                !cookies.photosUploadDrawerClickHintSeen &&
                posthog.getFeatureFlag('gesture-upload-photo-click') === 'show-gesture' && <ToolbarAnimatedHint />}
        </Dropzone>
    );
};

export default UploadPhotosButton;
